var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllChannelsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160769",
    "data-name": "Group 160769",
    transform: "translate(-290 -232.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160767",
    "data-name": "Group 160767",
    transform: "translate(290 232.416)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 11,
    cy: 11,
    r: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_160768",
    "data-name": "Group 160768",
    transform: "translate(18.583 175.881)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    cx: 0.907,
    cy: 0.907,
    r: 0.907,
    transform: "translate(281.5 61.278)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_103",
    cx: 0.907,
    cy: 0.907,
    r: 0.907,
    transform: "translate(281.5 71.978)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    y2: 4.682,
    transform: "translate(282.5 63.087)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    y2: 4.21,
    transform: "translate(282.5 67.768)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100-2",
    "data-name": "Ellipse_100",
    cx: 0.907,
    cy: 0.907,
    r: 0.907,
    transform: "matrix(0.602, 0.799, -0.799, 0.602, 286.858, 63.045)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_103-2",
    "data-name": "Ellipse_103",
    cx: 0.907,
    cy: 0.907,
    r: 0.907,
    transform: "matrix(0.602, 0.799, -0.799, 0.602, 278.313, 69.485)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7-2",
    "data-name": "Line_7",
    y2: 4.682,
    transform: "matrix(0.602, 0.799, -0.799, 0.602, 286.016, 64.932)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8-2",
    "data-name": "Line_8",
    y2: 4.21,
    transform: "matrix(0.602, 0.799, -0.799, 0.602, 282.277, 67.75)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100-3",
    "data-name": "Ellipse_100",
    cx: 0.907,
    cy: 0.907,
    r: 0.907,
    transform: "matrix(-0.588, 0.809, -0.809, -0.588, 288.003, 70.48)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_103-3",
    "data-name": "Ellipse_103",
    cx: 0.907,
    cy: 0.907,
    r: 0.907,
    transform: "matrix(-0.588, 0.809, -0.809, -0.588, 279.346, 64.19)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7-3",
    "data-name": "Line_7",
    y2: 4.682,
    transform: "matrix(-0.588, 0.809, -0.809, -0.588, 285.952, 70.225)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8-3",
    "data-name": "Line_8",
    y2: 4.21,
    transform: "matrix(-0.588, 0.809, -0.809, -0.588, 282.165, 67.474)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllChannelsIcon);
export default __webpack_public_path__ + "static/media/all-channels-icon.0de243795aa1371668db0ea6c564503f.svg";
export { ForwardRef as ReactComponent };